export default __webpack_public_path__ + "static/Discussion-0628f7c60a0a5b4f6b0f0d24d6eb0acd.jpg";